<template>
  <div
    v-bind:class="{ active: show }"
    class="modal modal-sm"
    role="dialog"
    aria-modal="true"
    aria-labelledby="config-modal-title"
  >
    <a
      v-on:click="close"
      class="modal-overlay"
      role="region"
      aria-label="Close dialog"
    />
    <div class="modal-container">
      <div class="modal-header">
        <a
          v-on:click="close"
          class="btn btn-clear float-right"
          role="button"
          aria-label="Close dialog"
        />
        <div id="config-modal-title" class="modal-title h5">
          Diagram Settings
        </div>
      </div>
      <div class="modal-body">
        <div class="content">
          <form>
            <div class="form-group">
              <label class="form-label">Graph View</label>
              <select
                v-model="ConfigStore.graphView"
                class="form-select select-sm"
              >
                <option value="initial">Initial State</option>
                <option value="pf">Power Flow Results</option>
                <option value="opf">OPF Results</option>
              </select>
            </div>

            <div class="form-group">
              <div class="input-group">
                <label class="form-checkbox">
                  <input
                    v-model.number="ConfigStore.busNumbers"
                    type="checkbox"
                    id="bus-numbers"
                  />
                  <i class="form-icon"></i> Display Bus Numbers
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="input-group">
                <label class="form-checkbox">
                  <input
                    v-model.number="ConfigStore.deviceLabels"
                    type="checkbox"
                    id="device-labels"
                  />
                  <i class="form-icon"></i> Display Device Labels
                </label>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Branch Power Flows</label>
              <label class="form-radio form-inline">
                <input
                  type="radio"
                  value="active"
                  v-model="ConfigStore.branchFlows"
                />
                <i class="form-icon"></i> Active
              </label>
              <label class="form-radio form-inline">
                <input
                  type="radio"
                  value="reactive"
                  v-model="ConfigStore.branchFlows"
                />
                <i class="form-icon"></i> Reactive
              </label>
            </div>

            <div class="form-group">
              <label class="form-label">View Mode</label>
              <label class="form-radio form-inline">
                <input
                  type="radio"
                  value="2D"
                  v-model="ConfigStore.graph"
                  v-on:click="close"
                />
                <i class="form-icon"></i> 2D
              </label>
              <label class="form-radio form-inline">
                <input
                  type="radio"
                  value="3D"
                  v-model="ConfigStore.graph"
                  v-on:click="close"
                />
                <i class="form-icon"></i>
                <span class="tooltip" data-tooltip="Experimental">3D</span>
              </label>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigStore from "../stores/ConfigStore";

export default {
  name: "ConfigModal",
  props: ["show"],
  data() {
    return {
      ConfigStore: ConfigStore.data.config
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
